<mpro-dropdown
  title="Country & Region"
  [inputValue]="getInputString()"
  (search)="search($event)"
  [permanentlyOpened]="permanentlyOpened"
  (toggle)="dropdownStateChange($event)"
  #dropdown
>
  <div [ngSwitch]="state">
    <div *ngSwitchCase="'addNew'" class="custom-region-content-wrapper">
      <mpro-custom-region
        [countries]="countries"
        [preSelectedCountries]="filters.regionSelection.getCountryCodes() || []"
        (save)="onSave($event)"
        (cancel)="setState('default')"
        [region]="inEditRegion"
      >
      </mpro-custom-region>
    </div>
    <div class="dropdown-content-wrapper" *ngSwitchDefault>
      <div class="search-wrapper">
        <div class="search-input">
          <mpro-text-input
            [searchSign]="true"
            [(ngModel)]="searchValue"
            (ngModelChange)="search($event)"
            [placeholder]="
              isCitiesEnabled
                ? 'Search for a country or city'
                : 'Search for a country'
            "
          >
          </mpro-text-input>
        </div>
        <div class="clear-button">
          <button
            class="mpro-btn mpro-btn-secondary"
            (click)="clearSelection()"
          >
            <fa-icon [icon]="faTrash" class="clear-data-icon"></fa-icon>
            <span>clear selection</span>
          </button>
        </div>
      </div>
      <div class="sections-wrapper">
        <div class="section-wrapper">
          <div
            [class]="
              searchValue !== '' && isCitiesEnabled
                ? 'section'
                : 'continents-sections section'
            "
          >
            <div class="world-checkbox">
              <mpro-checkbox
                [checked]="true"
                [indeterminate]="!dataFilters.regionSelection.world"
                [label]="'The World'"
                (checkboxChange)="onWorldSelected()"
                #worldCheckbox
              >
              </mpro-checkbox>
            </div>
            <ng-container *ngIf="searchValue === ''">
              <div class="title-label">continents</div>
              <ng-container *ngIf="!isCitiesEnabled; else cityRegionsTemplate">
                <mpro-checkable-dropdown-item
                  *ngFor="let r of systemRegions"
                  [leftText]="r.name"
                  [class.inverse-hover]="lastHoveredContinent === r"
                  [rightText]="'(' + r.countries.length + ')'"
                  [disabled]="
                    !r.countries.length || r.disabled || !!dataFilters.dataLens
                  "
                  (itemChecked)="onRegionSelected(r, false, $event)"
                  [showLock]="!r.countries.length"
                  [checked]="false"
                  (mouseenter)="onContinentsHovered(r, false, $event)"
                  [arrow]="true"
                >
                </mpro-checkable-dropdown-item>
              </ng-container>
              <ng-template #cityRegionsTemplate>
                <mpro-checkable-dropdown-item
                  *ngFor="let r of cityRegions"
                  [leftText]="r.name"
                  [class.inverse-hover]="lastHoveredContinent === r"
                  [rightText]="'(' + r.subTerritoriesCount + ')'"
                  [disabled]="
                    !r.subTerritoriesCount ||
                    r.disabled ||
                    !!dataFilters.dataLens ||
                    !isContinentAllowed(r)
                  "
                  (itemChecked)="onCitiesRegionSelected(r, $event)"
                  [showLock]="!r.subTerritoriesCount"
                  [checked]="isRegionChecked(r)"
                  [overrideCheckbox]="true"
                  [indeterminate]="
                    isRegionIndeterminate(r) &&
                    !dataFilters.regionSelection.regions.has(r.name)
                  "
                  [loading]="r.loading || false"
                  (mouseenter)="onContinentsHovered(r, false, $event)"
                  [arrow]="true"
                >
                </mpro-checkable-dropdown-item>
              </ng-template>
            </ng-container>

            <div class="countries-searched-wrapper" *ngIf="searchValue !== ''">
              <div class="title-label">Countries</div>
              <ng-container *ngFor="let c of filteredCountries">
                <mpro-checkable-dropdown-item
                  [leftText]="c.name"
                  [showLock]="!!c.authDisabled"
                  [disabled]="
                    (authService.isLoggedIn() && c.authDisabled) ||
                    c.disabled ||
                    !!dataFilters.dataLens
                  "
                  [arrow]="
                    !!(
                      c.subnational &&
                      c.subnational.length &&
                      !doNotShowSubnational
                    )
                  "
                  (click)="preventClick($event)"
                  (itemChecked)="onCountrySelected(c, $event)"
                  [checked]="
                    dataFilters.regionSelection.countries.has(c.code) || false
                  "
                  (mouseenter)="onCountriesHovered(c, $event)"
                >
                </mpro-checkable-dropdown-item>
              </ng-container>
            </div>

            <hr />
            <div class="region-wrapper">
              <ng-template #yourRegions>
                <div class="title-label">Your regions</div>
                <div class="subtitle" *ngIf="!userRegions.length">
                  You do not have any regions added yet.
                </div>
                <div *ngIf="!hideNewRegionButton" class="new-btn-wrapper">
                  <button
                    blockOnClickEvent
                    [condition]="isFreemium || false"
                    [requestCategory]="'New Region'"
                    [callback]="authService.openFreemiumRequestModal"
                    (click.checkBlockEvent)="setAddNew(true)"
                    class="mpro-btn mpro-btn-secondary new-btn"
                    (click)="setState('addNew')"
                    stopClickPropagation
                  >
                    <fa-icon [icon]="faPlus"></fa-icon>
                    <span>Create New Region</span>
                    <fa-icon
                      *ngIf="!authService.isLoggedIn() || isFreemium"
                      [icon]="faLock"
                    ></fa-icon>
                  </button>
                </div>
                <mpro-checkable-dropdown-item
                  class="inverse-hover"
                  *ngFor="let r of userRegions"
                  [editable]="true"
                  [class.inverse-hover]="lastHoveredContinent === r"
                  [leftText]="r.name"
                  (editClicked)="onEditClicked(r)"
                  (deleteClicked)="onDeleteClicked(r)"
                  [rightText]="'(' + r.countries.length + ')'"
                  [disabled]="r.disabled || !!dataFilters.dataLens"
                  (itemChecked)="onRegionSelected(r, true, $event)"
                  (mouseenter)="onContinentsHovered(r, true, $event)"
                  [indeterminate]="
                    isRegionIndeterminate(r, true) &&
                    !dataFilters.regionSelection.regions.has(r.name)
                  "
                  [checked]="
                    isRegionIndeterminate(r, true) ||
                    dataFilters.regionSelection.regions.has(r.name) ||
                    false
                  "
                >
                </mpro-checkable-dropdown-item>
              </ng-template>
              <ng-container
                *ngIf="
                  !isCategoriesEnabled &&
                    citiesPermission &&
                    searchValue !== '';
                  else yourRegions
                "
              >
                <div class="title-label">CITIES</div>

                <div class="section-wrapper city-loader-wrapper">
                  <div class="section">
                    <mpro-loading *ngIf="loadingCitiesSearch"></mpro-loading>
                  </div>
                  <mpro-checkable-dropdown-item
                    *ngFor="let c of searchCitiesResult"
                    [leftText]="c.cityId"
                    (click)="preventClick($event)"
                    (itemChecked)="onSearchedCitySelected(c, $event)"
                    [checked]="
                      dataFilters.regionSelection.cities.has(c.cityId) || false
                    "
                  >
                  </mpro-checkable-dropdown-item>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
        <div class="section-wrapper">
          <div class="section">
            <ng-container *ngIf="searchValue === ''">
              <div class="title-label">Countries</div>
              <div
                class="section"
                *ngIf="loadingCitiesCountries; else cityCountriesList"
              >
                <mpro-loading></mpro-loading>
              </div>
              <ng-template #cityCountriesList>
                <ng-container *ngFor="let c of getCountries()">
                  <mpro-checkable-dropdown-item
                    *ngIf="!c.hidden"
                    [leftText]="c.name"
                    [showLock]="c.authDisabled || !!c.authDisabled"
                    [disabled]="
                      c.authDisabled ||
                      (authService.isLoggedIn() && c.authDisabled) ||
                      c.disabled ||
                      !!dataFilters.dataLens ||
                      loadingCitiesCountries
                    "
                    [arrow]="
                      !!(
                        c.subnational &&
                        c.subnational.length &&
                        !doNotShowSubnational
                      ) || !!c.subTerritoriesCount
                    "
                    [showLock]="isFreemium"
                    (click)="preventClick($event)"
                    (itemChecked)="onCountrySelected(c, $event)"
                    [checked]="
                      dataFilters.regionSelection.countries.has(c.code) || false
                    "
                    [rightText]="getCityCount(c)"
                    (mouseenter)="onCountriesHovered(c, $event)"
                    (mouseleave)="onMouseLeave()"
                  >
                  </mpro-checkable-dropdown-item>
                </ng-container>
              </ng-template>
            </ng-container>
          </div>
        </div>
        <ng-container *ngIf="cityList && searchValue === ''">
          <div
            class="section-wrapper city-loader-wrapper"
            [class.export]="export"
            *ngIf="loadingCities; else cityListWrapper"
          >
            <div class="section">
              <mpro-loading></mpro-loading>
            </div>
          </div>
          <ng-template #cityListWrapper>
            <div
              class="section-wrapper"
              [class.export]="export"
              *ngIf="cityList.length > 0"
              (mouseleave)="closeCitiesContainer()"
              (clickOutside)="closeCitiesContainer()"
            >
              <div class="section">
                <ng-container *ngIf="searchValue === ''">
                  <div class="title-label">Cities</div>
                  <mpro-alert
                    [displayIcon]="false"
                    [type]="'warning'"
                    *ngIf="isCategoriesEnabled"
                    class="p-2 mb-2"
                    [message]="
                      'Cities data is unavailable while the Categories Consumer Demand switch is turned on. To select cities, turn the switch off'
                    "
                  ></mpro-alert>
                  <ng-container *ngFor="let c of cityList">
                    <mpro-checkable-dropdown-item
                      [leftText]="c.name"
                      [showLock]="c.authDisabled || !!c.authDisabled"
                      [disabled]="
                        c.authDisabled ||
                        (authService.isLoggedIn() && c.authDisabled) ||
                        !!dataFilters.dataLens ||
                        isCategoriesEnabled
                      "
                      [readonly]="areCitiesDisabled()"
                      (click)="preventClick($event)"
                      (itemChecked)="onCitySelected(c, $event)"
                      [showLock]="isFreemium"
                      [checked]="
                        dataFilters.regionSelection.cities.has(c.name) || false
                      "
                      (mouseenter)="onMouseEnter($event)"
                      (mouseleave)="onMouseLeave()"
                    >
                    </mpro-checkable-dropdown-item>
                  </ng-container>
                </ng-container>
              </div>
            </div>
          </ng-template>
        </ng-container>
        <div class="section-wrapper" *ngIf="numCols === 3">
          <div class="section">
            <mpro-checkable-dropdown-item
              *ngFor="let p of filteredProvince"
              [leftText]="p.name"
              (itemChecked)="onProvinceSelected(p, $event)"
              [checked]="
                dataFilters.regionSelection.subnational.has(p.code) || false
              "
              [showLock]="!!p.authDisabled"
              [disabled]="!!p.authDisabled"
            ></mpro-checkable-dropdown-item>
          </div>
        </div>
      </div>
      <div class="bottom-section">
        <span class="countries-selected-label">
          {{
            !dataFilters.regionSelection.world
              ? dataFilters.regionSelection.cities.size >= 50
                ? dataFilters.regionSelection.countries.size +
                  " Countries Selected (Export Cities Limit: 50)"
                : dataFilters.regionSelection.countries.size +
                  " Countries Selected"
              : "All countries selected"
          }}
        </span>
        <button class="mpro-btn mpro-btn-primary" (click)="toggleDropdown()">
          done
        </button>
      </div>
    </div>
  </div>
</mpro-dropdown>

<div #tooltip hidden="true">
  <mpro-tooltip [options]="tooltipOptions"></mpro-tooltip>
</div>

<mpro-delete-modal
  [(open)]="isDeleteModalOpen"
  (onDelete)="onDelete()"
  [title]="'Delete Custom Region'"
>
  <mpro-dropdown-item
    class="inverse-hover delete-region-info"
    [leftText]="(regionForDeletion?.countries?.length || 0) + ' Countries'"
    [middleText]="regionForDeletion?.name || ''"
  >
  </mpro-dropdown-item>
</mpro-delete-modal>
